import { lazy } from 'react';

import { withSuspense } from '@/shared/lib/hocs/with-suspense.hoc';
import { PageLoader } from '@/widgets/page';

export const AuthorizationPage = withSuspense(
	lazy(() => import('./authorization-page.component')),
	PageLoader,
);
